import { render, staticRenderFns } from "./ContactNumber.vue?vue&type=template&id=2c12020f"
import script from "./ContactNumber.vue?vue&type=script&lang=js"
export * from "./ContactNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports